import Header from "./Header";
import HeroSection from "./HeroSection";
import BannerSwipeSection from "./BannerSwipeSection";
import FeaturesSection from "./FeaturesSection";
import TestimonialsSection from "./TestimonialsSection";
import CTASection from "./CTASection";
import Footer from "../Footer/Footer";

export default function Homepage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#fff7f8]">
      {/* Abstract red-white gradient background */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-red-300 to-red-500" />
        <div className="absolute -top-28 -left-24 h-[500px] w-[500px] rounded-full bg-red-800/70 blur-3xl" />
        <div className="absolute top-24 right-[-120px] h-[420px] w-[420px] rounded-full bg-red-500/45 blur-3xl" />
        <div className="absolute bottom-[-120px] left-1/2 h-[460px] w-[780px] -translate-x-1/2 rounded-full bg-white/80 blur-3xl" />
        <div className="absolute top-[28%] left-[-10%] h-44 w-[120%] rotate-[-10deg] bg-gradient-to-r from-white/0 via-white/35 to-white/0 blur-2xl" />
        <div className="absolute top-[52%] left-[-15%] h-52 w-[130%] rotate-[-6deg] bg-gradient-to-r from-red-900/20 via-red-600/10 to-white/0 blur-2xl" />
      </div>

      <div className="relative z-10">
        <Header />
        <main>
          {/* Hero Section */}
          <HeroSection />
          {/* Swipe Banner Section */}
          <BannerSwipeSection />
          {/* CTA Button Section */}
          <section className="px-4 sm:px-6 lg:px-8 py-6 -mt-4 flex justify-center">
            <a
              href="https://tiengtrung86hsk.com/lien-he/"
              className="text-black inline-block bg-red-600 hover:bg-red-700 text-white font-bold text-xl py-4 px-12 rounded-lg shadow-lg transition-colors duration-200"
            >
              ĐĂNG KÝ HỌC NGAY
            </a>
          </section>
          {/* Features Section */}
          <FeaturesSection />
          {/* Testimonials Section */}
          <TestimonialsSection />
          {/* CTA Section */}
          <CTASection />
        </main>
        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}
